// Slider.js
import React, { useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel';
// import { Carousel } from 'react-responsive-carousel';
// import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Button } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';

const Slider = ({ data, isSliderText }) => {
  const isSmallScreen = useMediaQuery('(max-width:768px)');

  const navigate = useNavigate();
  const carouselStyle = {
    height: isSmallScreen ? '100%' : '55vh',
    position: 'relative',
    margin: "auto"
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: !isSmallScreen && 'cover',
    position: !isSmallScreen && 'absolute',
    top: !isSmallScreen && 0,
    left: !isSmallScreen && 0,
    // zIndex: -1,
  };

  const captionStyle = {
    top: "50%",
    left: isSmallScreen ? "5%" : "20%",
    textAlign: 'left',
    color: 'white',
    transform: "translateY(-50%)",
    width: isSmallScreen ? "90%" : '30%',

    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  };
  return (
    <Carousel
      autoPlay={true}
      interval={5000}
      infiniteLoop={true}
      showThumbs={false}
      swipeable={true}
      style={carouselStyle}
    >
      {data?.map((val, idx) => (
        <Carousel.Item style={{ height: isSmallScreen ? "100%" : '55vh', position: 'relative', cursor: val?.url && "pointer" }} key={idx}
          onClick={() => val?.url && window.open(val.url, '_blank')}
        >
          <img
            src={val.image}
            alt={`Slide ${idx + 1}`}
            loading='lazy'
            style={imageStyle}

            onError={(e) => {
              e.currentTarget.src = val.image;
            }}
          />
          {isSliderText &&
            <Carousel.Caption style={captionStyle}
            // style={{
            //   top: "50%", left: 150,
            //   bottom: "auto"
            // }}
            >
              <h1 style={{ lineHeight: 1.5, textAlign: "left", fontSize: isSmallScreen && "1.5em" }}>
                <span>
                  Enhancing
                  {/* Shareholder */}
                </span>
                <span className="bold" style={{ color: "#07588f" }}>
                  {" "}Knowledge,
                </span>
                <span className="bold" style={{ color: "#16b2b0" }}>
                  {" "}Fostering
                  Engagement
                </span>
                <span className="bold" style={{ color: "#000000" }}>
                  {" "}& Empowering Shareholder
                </span>
                <Button onClick={() => navigate("/ShareHoldersRights/Documents")} style={{
                  backgroundColor: "#07588f",
                  color: "white",
                  borderRadius: "5em",
                  padding: !isSmallScreen && "15px 3em",
                  marginRight: "1em",
                }} variant="primary">Know your rights as a shareholders</Button>
              </h1>
            </Carousel.Caption>
          }
          {/* <p className="legend">{src}</p> */}
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default Slider;
